const INTERNAL_TAG_PREFIXES = [
  'capability:',
  'pattern:',
  'persona:',
  'entity_format:',
  'runtime_stress:',
  'mock_profile:',
  'simulation_mode:',
  'smoke_kind:',
]

const SYSTEM_TAG_VALUES = new Set([
  'clean_baseline',
  'messy_success',
  'recovery_success',
  'boundary_pressure',
  'happy_path',
  'boundary',
])

export const isSystemTag = (tag: string): boolean =>
  INTERNAL_TAG_PREFIXES.some((prefix) => tag.startsWith(prefix)) || SYSTEM_TAG_VALUES.has(tag)

export const filterUserTags = (tags: string[] | undefined): string[] =>
  (tags ?? []).filter((tag) => !isSystemTag(tag))
